<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Disqualify reasons') }}</h4>
        </div>
        <div>
          <div class="form-inline">
            <div class="form-group mr-2">
              <range-date-filter
                :value="rangeDate"
                @input="(v) => { setFilters({created_at: v}) }"
                style="min-width: 210px"> 
                </range-date-filter>
            </div>
            <button
              class="btn btn-light"
              @click="exportReport">
              {{ $t('Export xlsx') }}
              </button>
          </div>
        </div>
      </div>
    </div>

    <div class="vflex-row-1">

      <filterfy
        :models="filtersMap"
        :initFilters="filters"
        @changed="setFilters">

        <Paginaty
          :total="grid.length"
          :pages="0"
          :page="0"
          :creating="creating"
          :loading="loading"
          @changePage="setPage">
          
          <template slot="content" v-if="!creating">
            <div class="p-3">
              <highcharts
                :options="chartOptions">
                </highcharts>
            </div>
            
            <table class="table table-bordered">
              <thead class="thead-fixed">
                <tr>
                  <th-sort field="name" :value="sort" @input="setSort">Motivo</th-sort>
                  <th-sort field="total_placements" :value="sort" @input="setSort">{{ $t('Candidates') }}</th-sort>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in grid">
                  <th class="text-truncate">{{ item.name }}</th>
                  <td class="text-truncate">{{ item.total_placements }}</td>
                </tr>
              </tbody>
            </table>
          </template>

          <template slot="noresults">
            {{ $t('There are no items') }}
          </template>

        </Paginaty>

      </filterfy>
    </div>

  </div>

</template>

<script>
import {Chart} from 'highcharts-vue'
import ThSort from '@/components/Parts/ThSort'
import Filterfy from '@/components/Filterfy/Filterfy'
import Paginaty from '@/components/Paginaty/Paginaty'
import RangeDateFilter from './RangeDateFilter'
import BlobDownload from '@/utils/BlobDownload'
import FilterfyToQuery from '@/utils/FilterfyToQuery'
import moment from 'moment'

export default {
  name: 'ReportDisqualifyReasons',
  components: {
    highcharts: Chart,
    ThSort,
    Filterfy,
    Paginaty,
    RangeDateFilter
  },
  data () {
    return {
      creating: true,
      loading: true,
      filtersMap: [
        {
          'type': 'list',
          'label': this.$t('Stage'),
          'target': 'stage_id',
          'resource': 'stages'
        },
        {
          'type': 'list',
          'label': this.$t('Company'),
          'target': 'job.company_id',
          'resource': 'companies'
        },
        {
          'type': 'list',
          'label': this.$t('Department'),
          'target': 'job.departament_id',
          'resource': 'departaments'
        }
      ],
      grid: false
    }
  },
  computed: {
    chartOptions () {
      return {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
        },
        lang: {
          noData: this.$t('No data to display')
        },
        title: {
          text: this.$t('Disqualify reasons')
        },
        tooltip: {
          pointFormat: '<b>{point.percentage:.1f}%</b>'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.percentage:.1f} %'
            }
          }
        },
        series: [{
          data: this.grid.map((v) => {
            return {
              name: v.name,
              y: v.total_placements
            }
          })
        }]
      }
    },
    filters () {
      return this.$route.query
    },
    sort () {
      return this.$route.query.sort || '-total_placements'
    },
    rangeDate () {
      const defaultDate = `d|${moment().subtract(30, 'days').toISOString()}|${moment().toISOString()}`
      return this.$route.query.created_at === undefined ? defaultDate : this.$route.query.created_at
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.loading = true

      const params = {
        ...FilterfyToQuery(this.filters, this.filtersMap),
        created_at: this.rangeDate,
        page: this.$route.query.page || 1,
        sort: this.sort,
        limit: this.$default.limit
      }

      this.axios
      .get('/accounts/' + this.$store.getters.getAccount._id + '/reports/disqualify-reasons', {params: params})
      .then((response) => {
        this.grid = response.data
        this.loading = this.creating = false
      })
    },
    /*
    setFilters
    */
    setFilters (filters) {
      this.$changeUrlParam(filters)
      this.setPage(1)
    },
    setSort (sort) {
      this.$changeUrlParam({sort: sort})
      this.setPage(1)
    },
    setPage (page) {
      this.$changeUrlParam({page: page})
      this.loadData()
    },
    exportReport () {
      const params = {
        ...this.filters,
        sort: this.sort
      }

      this.axios
      .get('/accounts/' + this.$store.getters.getAccount._id + '/reports/disqualify-reasons/export', {params: params, responseType: 'blob', timeout: 30000})
      .then((response) => {
        BlobDownload(response)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Report/ReportDisqualifyReasons.vue